import React from 'react';
import PropTypes from 'prop-types';

import {Stack} from 'views/components';

const ClientCreate = (props) => {
  return (
    <Stack>

    </Stack>
  );
};
ClientCreate.propTypes = {
  oldData: PropTypes.object.isRequired,
  newData: PropTypes.object.isRequired,
};

export default React.memo(ClientCreate);
